//
//
//
//
//

export default{
  data(){
    return{
      func:''
    }
  },
  created(){
    this.$eventhub.$on('upvideo',func=>{
      this.func=func
      this.$refs.video.click();
    })
  },
  methods:{
    upload(){
      if(this.$refs.video.files[0]){
        let data = new FormData()
        data.append('files',this.$refs.video.files[0])
        this.$http.post('/mobile/upload/upvideo',data,{headers: { 'Content-Type': 'multipart/form-data' }}).then(res=>{
          if(res.data){
            this.func(res.data)
          }else{
            this.msg('上传失败')
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/upvideo.vue